let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("17usw")]).then(() => parcelRequire('6S2qG'));